/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Role_Operations_CoordinatorInputs */



/**
* | output |
* | --- |
* | "Operations Coordinator" |
*
* @param {Team_Role_Operations_CoordinatorInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const team_role_operations_coordinator = /** @type {((inputs?: Team_Role_Operations_CoordinatorInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Role_Operations_CoordinatorInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("运营协调员")
	return /** @type {LocalizedString} */ ("Operations Coordinator")
});